import { Component, OnInit, OnDestroy } from '@angular/core';
import { AuthenticationService } from '../services/authentication.service';
import { HeaderMenu } from './header-menu';
import { Router, NavigationEnd } from '@angular/router';
import { timer, Observable, Subscription, Subject } from 'rxjs';
import { map, take } from 'rxjs/operators';
import { LanguageService } from '../services/language.service';
import { TRANSLATE } from '../../shared/classes/translatable';
import { Agence } from '../shared/classes/agence';
import { Bureau } from '../shared/classes/bureau';
import { EventService } from '../../shared/services/event.service';
import { StorageService } from '../../shared/services/storage.service';
import { AlertService } from '../../shared/services/alert.service';
import { Role } from '../../identite/shared/classes/role';
import { ConfigurationService } from '../../configuration/shared/services/configuration.service';
import { ConfigurationClientService } from '../services/configuration-client.service';
import { AgenceService } from '../../agence/shared/services/agence.service';
import { DomSanitizer } from '@angular/platform-browser';
import { Organisation } from '../shared/classes/organisation';
import { AclAccess } from '../../configuration/shared/classes/acl_access';
import { Z16ProEntiteService } from "../../z16pro/services/z16pro.entite.service";
import { Entite } from "../../z16pro/classes/entite";
import { Batiment } from '../../infrastructure/shared/classes/batiment';
import { InfrastructureService } from '../../infrastructure/shared/services/infrastructure.service';
import { IdentiteService } from '../../identite/shared/services/identite.service';
import { Mode } from '../shared/enum/mode';

@Component({
    selector: 'app-header',
    templateUrl: './header.component.html',
    styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements OnInit, OnDestroy {

    currentUser: any;
    menuItems: HeaderMenu[];
    menuRightItems: HeaderMenu[];
    navigationSubscription;
    _timeRemaining = 3600;
    countdown: Observable<any>;
    langues: any;
    currentLng = 'fr';
    aclList: any;
    aclLot: AclAccess;
    aclProspect: AclAccess;
    subLng: Subscription;
    subLangues: Subscription;
    subProspect: Subscription;
    subLot: Subscription;
    subAcl: Subscription;
    bureaux: Bureau[];
    maitres: Role[];
    batiments: Batiment[];
    currentBureau: Bureau;
    currentMaitre: Role;
    currentBatiment: Batiment;
    currentAgence: Agence;
    configuration: any;
    lastProspects: Role[];
    logoSub: any;
    reloadBureauxSub: any;
    time = Math.floor(Math.random() * 1000);
    expireSoon = false;
    nbRdv = 0;
    logoUrl = '/assets/organization_logo.png';
    editeurLogoUrl = '/assets/parent_organization_logo.png';
    filteredUrlPatterns = [
        'publication-check', 'agenda/rdv/today-count', 'derniers-lots', 'derniers-prospects', 'dernieres-actions',
        'passerelle/etat/1/publications/1', 'infrastructure/mandant/', 'callback/etat/0'
    ];
    versionNote: any;
    organisation: Organisation;
    entitesZ16Pro: Entite[];

    cciHeaderFooterColor: string;
    cciSubmenusColor: string;
    cciNavTextColor: string;
    displayCoda: boolean = false;
    cciMinDeportTelechargementFacture: number;
    isCreahaus: boolean = false;

    private killTrigger: Subject<void> = new Subject();
    private refreshInterval$: Subscription;
    private mode: Mode;

    get canUseEchangeDonnees() {
        return this.configuration && this.configuration.echange_donnees == '1';
    }


    constructor(
        private authService: AuthenticationService,
        private eventService: EventService,
        private alertService: AlertService,
        private router: Router,
        private lngService: LanguageService,
        private agenceService: AgenceService,
        private storageService: StorageService,
        private sanitizer: DomSanitizer,
        private z16ProEntiteService: Z16ProEntiteService,
        private infraService: InfrastructureService,
        private identiteService: IdentiteService,
        private configService: ConfigurationService,
        private configClientService: ConfigurationClientService
    ) {
        this.menuItems = [];
        this.bureaux = [];
        this.maitres = [];
        this.batiments = [];
        this.langues = [];
        this.lastProspects = [];
        this.currentLng = this.lngService.getCurrentLanguageCode();
        
        this.logoUrl = this.storageService.getLogoUrl() + 'organization_logo.png';
        this.editeurLogoUrl = this.storageService.getLogoUrl() + 'parent_organization_logo.png';

        this.navigationSubscription = this.router.events.subscribe((e: any) => {
            // If it is a NavigationEnd event re-initalise the component
            if (e instanceof NavigationEnd) {
                if (this.currentUser && e.url === '/login') {
                    // Déconnexion ?
                    this.currentUser = null;
                    if (this.refreshInterval$) {
                        this.refreshInterval$.unsubscribe();
                    }
                } else {
                    this.currentUser = JSON.parse(localStorage.getItem('currentUser'));
                    if (this.currentUser) {
                        const currBureauStorage = JSON.parse(localStorage.getItem('bureau'));
                        const currMaitreStorage = JSON.parse(localStorage.getItem('maitreOuvrage'));
                        const currBatimentStorage = JSON.parse(localStorage.getItem('batiment'));
                        // Si bureau vaut null, on crée un bureau avec id 0 pour simuler le bureau 'Tous' pour le select du breadcrumb
                        this.currentBureau = (currBureauStorage !== null ? new Bureau(currBureauStorage) : new Bureau({id: '0'}));
                        this.currentMaitre = (currMaitreStorage !== null ? new Role(currMaitreStorage) : new Role({id: '0'}));
                        this.currentBatiment = (currBatimentStorage !== null ? new Batiment(currBatimentStorage) : new Batiment({id: '0'}));
                        
                        
                        this.currentAgence = new Agence(JSON.parse(localStorage.getItem('agence')));

                        this.authService.checkExpiration();
                        
                        const _config = JSON.parse(localStorage.getItem('configuration'));
                        if (_config) {
                            this.storageService.setConfiguration(_config);
                            this.configuration = _config;
                            this.isCreahaus = _config.methode_numerotation_facture === 'creahaus';
                        }

                        // Récupération des ACL via localStorage
                        this.aclList = JSON.parse(localStorage.getItem('acl'));
                        if (this.aclList) {
                            this.storageService.setAcl(this.aclList, false);
                            this.processHeaderMenu(this.currentLng);

                        }

                        const config = JSON.parse(localStorage.getItem('configuration'));
                        if (config) {
                            this.storageService.setConfiguration(config);
                        }
                    }
                }
            }
        });
        
        // Récupération des ACL et construction du menu
        this.subAcl = this.storageService.aclEvent.subscribe(lstAcl => {
            this.aclList = lstAcl;
            this.getHeaderMenu();
        });

        this.subLng = this.lngService.currentLanguageCodeEvent.subscribe(lng => {
            this.currentLng = lng;
        });

        this.subLangues = this.lngService.LanguagesEvent.subscribe(langues => {
            this.langues = langues;
        });

        this.subProspect = this.eventService.prospectEvent.subscribe((prospect: Role) => {
            if (this.lastProspects.length >= 3) {
                // Pas plus de 3 prospects dans le tableau
                this.lastProspects = this.lastProspects.slice(1);
            }
            this.lastProspects.push(prospect);
        });

        this.storageService.configurationClientSub.subscribe(configurationClient => {
            this.mode = configurationClient.cci_mode_a_17;  
            this.displayCoda = configurationClient.cci_coda === '1' ? true : false;
        });
    }

    ngOnInit() {
        this.aclLot             = new AclAccess(this.storageService.getAcl('lots'));
        this.aclProspect        = new AclAccess(this.storageService.getAcl('prospects'));

        this.getOrganisation();

        this.authService.timerEvent.subscribe(timerLeft => {
            this._timeRemaining = (timerLeft * 1000);
            if (timerLeft > 0) {
                this.startCounter();
                this.getBureaux();
                this.getMaitres();
                this.getBatiments();
                //this.storageService.clearCache("bureau_agence");
            }
        });

        this.logoSub = this.eventService.logoEvent
        .subscribe(bureau => {
            this.time++;
        });

        this.configClientService.getConfiguration()
        .subscribe(retour => {
            if (retour.status === 200) {
                this.cciHeaderFooterColor = retour.data.cci_header_footer_color;
                this.cciSubmenusColor = retour.data.cci_submenus_color;
                this.cciNavTextColor = retour.data.cci_nav_text_color;
                this.cciMinDeportTelechargementFacture = retour.data.cci_min_deport_telechargement_facture;
            }
        });
        

        this.reloadBureauxSub = this.eventService.reloadBureauxEvent
        .subscribe(result => {
            this.getBureaux();
            this.getMaitres();
            this.getBatiments();
        });
    }

    ngOnDestroy() {
        if (this.navigationSubscription) {
            this.navigationSubscription.unsubscribe();
        }
        if (this.authService.timerEvent) {
            this.authService.timerEvent.unsubscribe();
        }
        if (this.lngService.currentLanguageCodeEvent) {
            this.lngService.currentLanguageCodeEvent.unsubscribe();
        }
        if (this.lngService.LanguagesEvent) {
            this.lngService.LanguagesEvent.unsubscribe();
        }
        if (this.logoSub) {
            this.logoSub.unsubscribe();
        }
        if (this.reloadBureauxSub) {
            this.reloadBureauxSub.unsubscribe();
        }
        this.subProspect.unsubscribe();
        this.subLot.unsubscribe();
        this.killTrigger.next();
        this.refreshInterval$.unsubscribe();
    }

    logout() {
        this.authService.logout();
    }

    startCounter() {
        this.countdown = timer(0, 60000).pipe(
            take(this._timeRemaining),
            map(() => {
                this._timeRemaining = this._timeRemaining - 60000;
                if (!this.expireSoon && this._timeRemaining <= (60000 * 60) ) {
                    this.expireSoon = true;
                    this.alertService.warn(TRANSLATE('Votre session expire bientôt'));
                }
                return this._timeRemaining;
            })
        );
    }

    getVersionNote() {
        this.agenceService.getVersionNote()
        .subscribe(retour => {
            if (retour.status === 200) {
                this.versionNote = this.sanitizer.bypassSecurityTrustHtml(retour.data);
            }
        });
    }


    getHeaderMenu(): void {
        this.menuItems = [];

        this.menuItems.push(new HeaderMenu('/dashboard', TRANSLATE('Dashboard'), 'industry'));

        const identiteChildren = [];
        if (this.aclList && this.aclList.identites && this.aclList.identites.read) {
            if (this.aclList.proprietaires && this.aclList.proprietaires.read) {
                identiteChildren.push(new HeaderMenu('/identite/client', TRANSLATE('Clients'), 'user'));
            }
            if (this.aclList.prospects && this.aclList.prospects.read) {
                identiteChildren.push(new HeaderMenu('/identite/prospect', this.translateZ16ProEntity('prospect', TRANSLATE('Prospects')), 'user'));
            }
            if (this.aclList.fournisseur && this.aclList.fournisseur.read) {
                identiteChildren.push(new HeaderMenu('/identite/fournisseur', TRANSLATE('Fournisseurs'), 'dolly-flatbed'));
            }
            if (this.aclList.maitre_ouvrage && this.aclList.maitre_ouvrage.read && this.mode === Mode.PROMOTION) {
                identiteChildren.push(new HeaderMenu('/identite/maitre_ouvrage', TRANSLATE('Maîtres d’ouvrage'), 'hard-hat'));
            }
            if (this.aclList.contact && this.aclList.contact.read) {
                identiteChildren.push(new HeaderMenu('/identite/contact', this.translateZ16ProEntity('contact', TRANSLATE('Contacts')), 'address-book'));
            }
            this.menuItems.push(new HeaderMenu('/identite', TRANSLATE('Identités'), 'users', identiteChildren));
        }

        const FacturationChildren = [];
        if (this.aclList && this.aclList.facturation && this.aclList.facturation.read) {

            const clientChildren = [];
            const fournisseurChildren = [];
            const compteChildren = [];
            const libre = [];

            clientChildren.push(new HeaderMenu('/facturation/devis-client', TRANSLATE('Devis client'), 'business-time'));
            clientChildren.push(new HeaderMenu('/facturation/commandes-client', TRANSLATE('Commandes client'), 'briefcase'));
            clientChildren.push(new HeaderMenu('/facturation/factures-client', TRANSLATE('Factures client'), 'file-invoice'));
            if (
                this.cciMinDeportTelechargementFacture > 0 
                || (this.storageService.configurationClient && this.storageService.configurationClient.cci_min_deport_telechargement_facture > 0)
            ) {
                clientChildren.push(new HeaderMenu('/facturation/deport-telechargements', TRANSLATE('Déport téléchargements'), 'file-download'));
            }
            fournisseurChildren.push(new HeaderMenu('/facturation/devis', TRANSLATE('Devis fournisseurs'), 'business-time'));
            fournisseurChildren.push(new HeaderMenu('/facturation/commandes', TRANSLATE('Commandes fournisseurs'), 'briefcase'));
            fournisseurChildren.push(new HeaderMenu('/facturation/factures-fournisseur', TRANSLATE('Factures fournisseurs'), 'file-invoice'));

            if (this.isCreahaus)
            fournisseurChildren.push(new HeaderMenu('/facturation/suivi-fournisseur', TRANSLATE('Suivi fournisseurs'), 'file-invoice'));

            compteChildren.push(new HeaderMenu('/facturation/operation', TRANSLATE('Opérations'), 'file-invoice'));
            
            if (this.displayCoda)
            compteChildren.push(new HeaderMenu('/facturation/imports-coda', TRANSLATE('Imports d\'opérations'), 'file-invoice'));

            libre.push(new HeaderMenu('/facturation/libre/emission', TRANSLATE('Emission'), 'arrow-up'));
            libre.push(new HeaderMenu('/facturation/libre/reception', TRANSLATE('Réception'), 'arrow-down'));


            FacturationChildren.push(new HeaderMenu('/facturation', TRANSLATE('Clients'), 'file-invoice', clientChildren));
            FacturationChildren.push(new HeaderMenu('/facturation', TRANSLATE('Fournisseurs'), 'file-invoice', fournisseurChildren));
            FacturationChildren.push(new HeaderMenu('/facturation', TRANSLATE('Comptes'), 'file-invoice', compteChildren));

            if (this.mode === Mode.PROMOTION) {
                FacturationChildren.push(new HeaderMenu('/facturation', TRANSLATE('Libre'), 'file-invoice', libre));
            }
        }

        const configChildren = [];

        if (this.aclList && this.aclList.configuration && this.aclList.configuration.read) {
            // configChildren.push(new HeaderMenu('/agence', TRANSLATE('Agence'), 'building'));
            // configChildren.push(new HeaderMenu('/configuration/scoring', TRANSLATE('Scoring'), 'star'));
            configChildren.push(new HeaderMenu('/configuration/document-management', TRANSLATE('Document management'), 'folder-open'));
            configChildren.push(new HeaderMenu('/configuration/option', TRANSLATE('Options'), 'cogs'));
            configChildren.push(new HeaderMenu('/configuration/listing', TRANSLATE('Listing'), 'list-ul'));
            configChildren.push(new HeaderMenu('/configuration/critere-recherche', TRANSLATE('Critères recherche'), 'search'));
            configChildren.push(new HeaderMenu('/configuration/action', TRANSLATE('Actions'), 'comment-dots'));
            configChildren.push(new HeaderMenu('/configuration/personnalisation', TRANSLATE('Personnalisation'), 'palette'));

            if (this.configuration && this.configuration.z16Pro==='1'){
                configChildren.push(new HeaderMenu('/configuration/champs-personnalisables', TRANSLATE('Champs personnalisables'), 'cogs'));
            }

            configChildren.push(new HeaderMenu('/configuration/module-calcul-prix', TRANSLATE('Comptabilité'), 'percentage'));
            if (this.mode === Mode.PROMOTION) {
                configChildren.push(new HeaderMenu('/configuration/tableau-des-tranches', TRANSLATE('Tableaux des tranches'), 'cogs')); //TODO demander la traduction
                configChildren.push(new HeaderMenu('/configuration/poste-liste', TRANSLATE('Tableaux des postes'), 'cogs')); //TODO demander la traduction
            }

            if (this.aclList.etape && this.aclList.etape.read) {
                configChildren.push(new HeaderMenu('/etape/model-etape', TRANSLATE('Suivi d\'étapes'), 'tasks'));
            }

            if (this.canUseEchangeDonnees) {
                // TODO CHECK CONFIGURATION IN DB FOR ECHANGE DE DONNEES
                configChildren.push(new HeaderMenu('/configuration/echange-donnees', TRANSLATE('Echange de données'), 'exchange-alt'));
            }
        }

        if (this.aclList && ((this.aclList.lots && this.aclList.lots.read) || this.aclList.batiments && this.aclList.batiments.read)) {
            const infraChildren = [];
            if (this.aclList.batiments && this.aclList.batiments.read && this.mode === Mode.PROMOTION) { //TODO add new Acl
                infraChildren.push(new HeaderMenu('/infrastructure/projets', TRANSLATE('Projets'), 'project-diagram'));
            }
            if (this.aclList.batiments && this.aclList.batiments.read && this.mode === Mode.PROMOTION) {
                infraChildren.push(new HeaderMenu('/infrastructure/batiments', TRANSLATE('Bâtiments'), 'building'));
            }
            if (this.aclList.lots && this.aclList.lots.read) {
                infraChildren.push(new HeaderMenu('/infrastructure/lot', this.translateZ16ProEntity('bien', TRANSLATE('Lots')), 'home'));
            }
            this.menuItems.push(new HeaderMenu('/infrastructure', TRANSLATE('Infrastructures'), 'building', infraChildren));
        }

        if (this.aclList && this.aclList.employes && this.aclList.employes.read) {
            configChildren.push(new HeaderMenu('/identite/utilisateur', TRANSLATE('Utilisateurs'), 'user-tie'));
        }

        if (this.aclList && this.aclList.bureaux && this.aclList.bureaux.read) {
            configChildren.push(new HeaderMenu('/identite/bureau', TRANSLATE('Bureaux'), 'landmark'));
        }

        if (this.aclList && this.aclList.acl && this.aclList.acl.read) {
            configChildren.push(new HeaderMenu('/configuration/acl', TRANSLATE('Contrôle d\'accès'), 'lock'));
        }

        if (this.aclList && this.aclList.configuration && this.aclList.configuration.read) {
            configChildren.push(new HeaderMenu('/configuration/modele-fiche', TRANSLATE('Modèles de document'), 'file'));
        }

        if (this.aclList && this.aclList.configuration && this.aclList.configuration.read) {
            configChildren.push(new HeaderMenu('/configuration/sms', TRANSLATE('SMS'), 'mobile-alt'));
            configChildren.push(new HeaderMenu('/configuration/backup', TRANSLATE('Points de restauration'), 'database'));
        }

        if (FacturationChildren.length > 0 ) {
            this.menuItems.push(new HeaderMenu('/facturation', TRANSLATE('Facturation'), 'cog', FacturationChildren));
        }

        if (configChildren.length > 0) {
            this.menuItems.push(new HeaderMenu('/configuration', TRANSLATE('Configuration'), 'cog', configChildren));
        }

        /**Z16Gestion**/
        /*
        const gestionChildren = [];
        if (this.canUseZ16Gestion) {
            gestionChildren.push(new HeaderMenu('/z16gestion/bail', TRANSLATE('Baux'), 'file-signature'));
            gestionChildren.push(new HeaderMenu('/z16gestion/loyer', TRANSLATE('Loyers'), 'hand-holding-usd'));
            gestionChildren.push(new HeaderMenu('/z16gestion/facture', TRANSLATE('Factures'), 'file-invoice-dollar'));
            gestionChildren.push(new HeaderMenu('/z16gestion/banque', TRANSLATE('Banques'), 'exchange-alt'));
            gestionChildren.push(new HeaderMenu('/z16gestion/proprietaire', this.translateZ16ProEntity('proprietaire', TRANSLATE('Propriétaires')), 'users'));
            this.menuItems.push(new HeaderMenu('/z16gestion', TRANSLATE('Gestion'), 'tasks', gestionChildren));
        }*/

        /*
        // On désactive le menu media quand Z16GestionOnly est actif
        if (! this.isZ16GestionOnly && this.aclList.passerelle && this.aclList.passerelle.read && this.aclList.medias && this.aclList.medias.read) {
            this.menuItems.push(new HeaderMenu('/passerelle', TRANSLATE('Médias'), 'cog'));
        }*/

        // console.log(this.configuration);
        // console.log("ok");    

        // this.configurationService.getConfiguration()
        // .subscribe(retour => {
        //     if (retour.status === 200) {
        //         console.log(retour.data);
                
        //     }
        // });
        
        // this.headerFooterColor = this.configuration.header_footer_color;
        // this.submenusColor = this.configuration.submenus_color;
        // this.navTextColor = this.configuration.nav_text_color;
    }

    changeHeaderFooterColor(): any {
        return { 'background-color': this.cciHeaderFooterColor };
    }

    changeSubmenusColor(): any {
        return { 'background-color': this.cciSubmenusColor };
    }

    changeNavTextColor(): any {
        return { 'color': this.cciNavTextColor };
    }

    useLang(language: string) {
        const found = this.langues.find((lng) => lng.lng_ref === language);
        if (found) {
            this.lngService.setCurrentLanguage(language);
            return;
        }
        const alternativeFound = this.langues.find((lng) => lng.lng_ref.indexOf(language + '-') > -1);
        this.lngService.setCurrentLanguage(alternativeFound.lng_ref);
        return;
    }

    getBureaux() {
        this.bureaux = [];
        this.agenceService.getBureaux(this.currentAgence.id)
        .subscribe(retour => {
            if (retour.status === 200) {
                retour.data.forEach(element => {
                    this.bureaux.push(new Bureau(element));
                });
            } else {

            }
            this.eventService.emitBureauxEvent(this.bureaux);
            this.storageService.setBureaux(this.bureaux);
        });
    }

    getBatiments() {
        this.batiments = [];
        if(this.currentMaitre && this.currentMaitre.id  && this.currentMaitre.id !== '0'){
            this.infraService.getBatimentsByMaitre(this.currentMaitre.id)
            .subscribe(retour => {
                if (retour.status === 200) {
                    this.batiments = retour.data;
                }
                this.eventService.emitBatimentEvent(this.batiments);
                this.storageService.setBatiments(this.batiments);
            }); 
        }

    }

    getMaitres() {
        this.maitres = [];

        this.identiteService.getIdentiteFiltered('maitre_ouvrage', null, null, null, null, null, 'hydrate')
            .subscribe(retour => {
                if(retour.status === 200) {
                    this.maitres = retour.data;
                }
            
            this.eventService.emitMaitreEvent(this.maitres);
            this.storageService.setMaitres(this.maitres);
            });
    }

    resetStorage() {
        this.storageService.navStorage.setReset(true);
    }

    getOrganisation() {
        this.organisation = new Organisation();
        this.agenceService.getOrganisation()
        .subscribe(retour => {
            if (retour.status === 200) {
                this.organisation = retour.data;
            }
        });
    }

    get canUseZ16Gestion() {
        return this.configuration && this.configuration.z16Gestion == '1';
    }

    get isZ16GestionOnly() {
        return this.configuration && this.configuration.z16Gestion == '1' && this.configuration.affichage_z16Gestion_only == '1';
    }

    getZ16ProEntites(lngCode: string) {
        if (!this.configuration || !this.configuration.z16Pro || this.configuration.z16Pro === '0') {
            return;
        }

        this.entitesZ16Pro = [];
        this.z16ProEntiteService.getEntitesByLocale(lngCode)
            .subscribe(retour => {
                if (retour.status === 200) {
                    retour.data.forEach(entite => {
                        this.entitesZ16Pro.push(Entite.fromJson(entite));
                    });
                    this.storageService.setZ16ProEntite(this.entitesZ16Pro);
                    this.getHeaderMenu();
                } else {
                    this.alertService.error(TRANSLATE(retour.message));
                }
            });
    }

    processHeaderMenu(lngCode: string): void {
        if (!this.configuration || !this.configuration.z16Pro || this.configuration.z16Pro === '0') {
            this.getHeaderMenu();
        } else {
            this.getZ16ProEntites(lngCode);
        }
    }

     // Permet de récupérer la bonne ref pour afficher correctement le drapeau (pour les fichiers du genre fr-social.json)
     getLngRef(ref: string) {
        if (ref.indexOf('-') < 0) {
            return ref;
        }

        const exploded = ref.split('-');
        if (exploded.length <= 0) {
            return ref;
        }

        return exploded[0];
    }
    
    translateZ16ProEntity(code: string, originalTranslaction: string) {
        if (!this.configuration || !this.configuration.z16Pro  || this.configuration.z16Pro === '0' || !this.entitesZ16Pro || this.entitesZ16Pro.length === 0) {
            return originalTranslaction;
        }

        const foundEntite = this.entitesZ16Pro.find(entite => entite.code === code);

        if (foundEntite !== undefined) {
            return foundEntite.libelle;
        } else {
            return originalTranslaction;
        }
    }
}
